import React from 'react'
import Svg from '../Svg'
import { SvgProps } from '../types'

const Icon: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 67.517 25.947" {...props}>
      <defs>
        <clipPath id="clip-path-lost">
          <rect
            id="Rectangle_9"
            data-name="Rectangle 9"
            width="67.517"
            height="25.947"
            fill="none"
          />
        </clipPath>
      </defs>
      <g
        id="Group_7"
        data-name="Group 7"
        transform="translate(0 0)"
        clipPath="url(#clip-path-lost)"
      >
        <path
          id="Path_64"
          data-name="Path 64"
          d="M61.586,23.674,60.577,1.321,63.4,1.194l.162,3.594a.584.584,0,0,0,1.166-.053L64.535.558A.584.584,0,0,0,63.926,0l-3.984.18a.584.584,0,0,0-.557.61L59.5,3.334l-1.078.049a2,2,0,0,0-3.859.395,29.076,29.076,0,0,1-11.089,3.8.584.584,0,0,0,.166,1.156A30.46,30.46,0,0,0,54.59,5.114l.5,10.992a.584.584,0,1,0,1.166-.053L55.713,4.092v0h0a.829.829,0,0,1,1.656-.073l.779,17.266a.829.829,0,0,1-1.656.077h0v0l-.134-2.966a.584.584,0,1,0-1.166.053l.09,2c-4.845-2.2-10.376-3.072-17.407-2.509l-.395-8.746c1.446-.015,2.823-.084,4.139-.208a.584.584,0,1,0-.109-1.163q-1.946.182-4.083.2l-.071-1.568a2.264,2.264,0,0,0-4.46-.438,2,2,0,0,0-2.818,1.545,2,2,0,0,0-1.722.046L28.311,6.6a.584.584,0,0,0-.473-.546L15.164,3.617a.584.584,0,0,0-.693.6l.377,8.347-.916.041-.068-1.5a.584.584,0,0,0-.609-.557l-2.862.129a.584.584,0,0,0-.557.61l.068,1.5-1.5.068a.584.584,0,0,0-.557.609l.129,2.863a.584.584,0,0,0,.609.557l1.5-.067.068,1.5a.584.584,0,0,0,.609.557l2.862-.129a.584.584,0,0,0,.557-.609l-.068-1.5.916-.041.376,8.347a.584.584,0,0,0,.745.536l4.357-1.254a.584.584,0,0,0-.323-1.123l-3.646,1.049L15.671,4.9l11.5,2.212.622,13.793L22.608,22.4a.584.584,0,1,0,.323,1.122L28.554,21.9a.584.584,0,0,0,.422-.587l-.045-.994a2,2,0,0,0,1.719-.109A2,2,0,0,0,33.595,21.5a2.264,2.264,0,0,0,4.4-.838l-.071-1.568c7.1-.573,12.617.34,17.448,2.675a2,2,0,0,0,3.879.046l1.078-.049.115,2.551v.034a.577.577,0,0,0,.159.336l0,0,.007.007,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.005,0,0,0,0,0,0,0,.005,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0h0l0,0,0,0,0,0,0,0h0l0,0,0,0,0,0h0l0,0,.006,0h0l0,0,0,0h0l.006,0h0l0,0h0l0,0h0l0,0h0l0,0h0l0,0h0l0,0h0l0,0H60.8l0,0H60.8l0,0h.01l0,0h.007l.007,0,0,0h0l.014,0h.011l.006,0h.158l4.01-.181a.584.584,0,0,0,.557-.61L64.845,7.394a.584.584,0,1,0-1.166.053l.726,16.1Zm-2.3-3.03.991-.045L59.552,4.5l-.991.045ZM34,6.6l.641,14.216a1.1,1.1,0,0,0,2.19-.1L36.189,6.5A1.1,1.1,0,0,0,34,6.6M32.884,7.782l.539,11.95a.829.829,0,1,1-1.655.075L31.229,7.857a.829.829,0,1,1,1.656-.075M28.438,9.413a.829.829,0,1,1,1.656-.075l.41,9.1a.829.829,0,1,1-1.656.075ZM14.9,13.731l-1.5.068a.584.584,0,0,1-.61-.557l-.068-1.5-1.7.077.068,1.5a.584.584,0,0,1-.557.61L9.04,14l.077,1.7,1.5-.068a.584.584,0,0,1,.61.557l.068,1.5,1.7-.077-.068-1.5a.584.584,0,0,1,.557-.609l1.5-.068Z"
          transform="translate(-6.184 0)"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          id="Path_65"
          data-name="Path 65"
          d="M66.882,117.706H.636a.636.636,0,1,1,0-1.272H66.882a.636.636,0,1,1,0,1.272"
          transform="translate(0 -91.759)"
          fill="#fff"
        />
      </g>
    </Svg>
  )
}

export default Icon
